package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class LinkNonceRequestBody(
    @SerialName("authCode") val authorizationCode: String,
    @SerialName("id") val pendingDevicePin: String,
    @SerialName("state") val state: String)
